import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LineBar = styled.div`
  position: relative;
  width: 100%;
  height: ${pxToRem('14px')};
 
  /*;
  background-color: ${props => props.theme.colors.mainGray};
  z-index: ${props => props.total}; 
  */
  overflow: hidden;
  display: flex;
`;

export const PercentageLine = styled.div`
  width: ${props => `${Math.floor((props.quantity * 100) / props.total)}%`};
  height: ${pxToRem('14px')};
  border-radius: 0 ${pxToRem('20px')} ${pxToRem('20px')} 0;
  background-color: ${props => props.color};
  z-index: ${props => props.zIndex};
  &:first-child {
    border-radius: ${pxToRem('20px')};
  }

  &:not(:first-child) {
    margin-left: -${pxToRem('5px')};
  }
`;

export const Labels = styled.div`
  display: flex;
  flex-wrap: ${props =>
    (props.atGlance || props.privateFota ? 'no-wrap' : 'wrap')};
  margin-top: ${pxToRem('20px')};
  justify-content: ${props =>
    `${
      props.corporate
        ? props.atGlance
          ? 'flex-start'
          : 'space-between'
        : 'unset'
    }`};
  width: ${props =>
    `${props.corporate || props.privateFota ? '100%' : 'auto'}`};
`;

const statusFunction = props => {
  const style = css`
    &::before {
      content: '';
      height: ${pxToRem('8px')};
      width: ${pxToRem('8px')};
      border-radius: 50%;
      background-color: ${({ color }) => color};
      font-weight: bold;
      display: inline-block;
      margin-right: ${pxToRem('10px')};
    }
  `;

  return style;
};

export const Item = styled.div`
  width: ${props => (props.atGlance || props.privateFota ? 'auto' : '50%')};
  text-transform: capitalize;

  :not(:last-child) {
    margin-bottom: ${pxToRem('8px')};
    ${props =>
      (props.atGlance || props.privateFota) &&
      css`
        margin-right: ${pxToRem('32px')};
      `}
  }
  :is(:first-child) {
    ${props =>
      props.atGlance &&
      css`
        margin-left: ${pxToRem('22px')};
      `}
  }

  @media ${props => props.theme.device.laptop} {
    flex-direction: column;
    width: 100%;
  }
  ${props => statusFunction(props)}
`;

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: ${pxToRem('55px')};

  > div:not(:last-child)::after {
    content: '';
    display: inline-block;
    height: ${pxToRem('35px')};
    width: ${pxToRem('2px')};
    background-color: #dad7db;
    position: absolute;
    right: -${pxToRem('25px')};
  }
`;
